export default __webpack_public_path__ + "static/media/briefcase.9f50928f.svg";